module.exports = __webpack_public_path__ + "src/images/eventomania.png?054fc7ac435f7135bf209283527bf7fe";


//////////////////
// WEBPACK FOOTER
// ./src/images/eventomania.png
// module id = 889
// module chunks = 0